import validate from "/app/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@24.0.1_db0@0.3.2_eslint@9.29.0_jiti@2.4.2_f8ca231f4afe20430559746b3395265d/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@24.0.1_db0@0.3.2_eslint@9.29.0_jiti@2.4.2_f8ca231f4afe20430559746b3395265d/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}